import axios from "../utils/axios";

export default function fetchAcquiredCompanies(adminId, params) {
  return axios.get("/admin/" + adminId + "/acquired-companies", { params });
}
